export default __webpack_public_path__ + "static/media/BOND.056c5e44.svg";